/// <reference path="../generated/ModelsConsentManagementOptInReadApi.d.ts"/>
import { TimeService } from "../../services/TimeService";
import { AppUtils } from '../../utils/index';
export class AdvertisingConsentModel {
	private einwilligung: number;
	private email: number;
	private telefon: number;
	private telefon2: number;
	private herkunftsKz: string;
	private timeStamp: string;
	private insurancehint = false;
	private personalisierung = false;
	private trackingconsentversion: string;
	private trackingreferenceid: string;
	private companyidentifier: string;
	private companyidentifierreferencecode: string;
	private optIns: ConsentManagementOptInReadApi[];
	private unterlassungserklaerung: boolean;

	constructor(conscent = 0, email = 0, telephone = 0, herkunftsKz = "", insuranceHint = false) {
		this.einwilligung = conscent;
		this.email = email;
		this.telefon = telephone;
		this.herkunftsKz = herkunftsKz;
		this.insurancehint = insuranceHint;
		this.timeStamp = (new TimeService()).CurrentDate;
	}

	get Einwilligung(): number {
		return this.einwilligung;
	}

	set Einwilligung(value: number) {
		this.einwilligung = value;
	}

	get Email(): number {
		return this.email;
	}

	set Email(value: number) {
		this.email = value;
	}

	get Telefon(): number {
		return this.telefon;
	}

	set Telefon(value: number) {
		this.telefon = value;
	}

	get Telefon2(): number {
		return this.telefon2;
	}

	set Telefon2(value: number) {
		this.telefon2 = value;
	}

	get HerkunftsKz(): string {
		return this.herkunftsKz;
	}

	set HerkunftsKz(value: string) {
		this.herkunftsKz = value;
	}

	get TimeStamp(): string {
		return this.timeStamp;
	}

	set TimeStamp(value: string) {
		this.timeStamp = value;
	}

	private userIp: string;
	get UserIp(): string {
		return this.userIp;
	}

	set UserIp(value: string) {
		this.userIp = value;
	}

	get InsuranceHint(): boolean {
		return this.insurancehint;
	}

	set InsuranceHint(value: boolean) {
		this.insurancehint = value;
	}

	get Personalisierung(): boolean {
		return this.personalisierung;
	}

	set Personalisierung(value: boolean) {
		this.personalisierung = value;
	}

	get TrackingConsentVersion(): string {
		return this.trackingconsentversion;
	}

	set TrackingConsentVersion(value: string) {
		this.trackingconsentversion = value;
	}

	get TrackingReferenceId(): string {
		return this.trackingreferenceid;
	}

	set TrackingReferenceId(value: string) {
		this.trackingreferenceid = value;
	}

	get CompanyIdentifier(): string {
		return this.companyidentifier;
	}

	set CompanyIdentifier(value: string) {
		this.companyidentifier = value;
	}

	get CompanyIdentifierReferenceCode(): string {
		return this.companyidentifierreferencecode;
	}

	set CompanyIdentifierReferenceCode(value: string) {
		this.companyidentifierreferencecode = value;
	}

	get OptIns(): ConsentManagementOptInReadApi[] {
		return this.optIns;
	}

	set OptIns(value: ConsentManagementOptInReadApi[]) {
		this.optIns = value;
	}

	get Unterlassungserklaerung(): boolean {
		return this.unterlassungserklaerung;
	}

	set Unterlassungserklaerung(value: boolean) {
		this.unterlassungserklaerung = value;
	}

	public static createFromObject(dataObject: { [key: string]: any }): AdvertisingConsentModel {
		return AppUtils.Helper.createFromMap(dataObject, AdvertisingConsentModel);
	}
}
